module.exports = __webpack_public_path__ + "img/source-search_type-user.d77c8668.svg";